import {Breadcrumb, Tabs} from "antd";
import {Link, useParams} from "react-router-dom";
import {DashboardWrapper} from "../../../../layouts/dashboard-wrapper";
import {EditDiscountPageV2} from "../../../../discounts/useCases/update-discount-code/page-v2";
import {DiscountUsageDetail} from "../../../../discounts/useCases/get-discounts/usage-detail";
import {useGetDiscountCodeContext} from "../../../../discounts/useCases/update-discount-code/context";
import {StyledPageWrapper} from "../../../../styles/dashboard/calls/calls";

export function ViewDiscountCodePage() {
  const {id} = useParams<{id: string}>();
  const discountId = Number(id);

  const {
    state: {
      discountCodeData: {
        discount: {code},
      },
    },
  } = useGetDiscountCodeContext();

  return (
    <DashboardWrapper pageTitle="Discount details">
      <Breadcrumb style={{marginBottom: 24}}>
        <Breadcrumb.Item>
          <Link to="/discounts">Discounts</Link>
        </Breadcrumb.Item>
        <Breadcrumb.Item>{code}</Breadcrumb.Item>
      </Breadcrumb>
      <StyledPageWrapper>
        <div className="main-area">
          <Tabs defaultActiveKey="information">
            <Tabs.TabPane tab="Discount information" key="information">
              <EditDiscountPageV2 />
            </Tabs.TabPane>
            <Tabs.TabPane tab="Usage history" key="usage">
              <DiscountUsageDetail discountId={discountId} />
            </Tabs.TabPane>
          </Tabs>
        </div>
        <div className="widget-area"></div>
      </StyledPageWrapper>
    </DashboardWrapper>
  );
}
